import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownItem } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-shortcuts-card',
  standalone: true,
  imports: [CommonModule, NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownItem],
  templateUrl: './shortcuts-card.component.html',
  styleUrl: './shortcuts-card.component.scss'
})
export class ShortcutsCardComponent {

}
